import { createContext } from 'react';
import {ID, Response} from '../../../../../_dashboard/helpers'

export interface About {
  email: string;
  phone:string;
  adress:string;
  description?:string;
}


export const initialAbout: About = {

  
    email: '',
    phone: '',
    adress:'',
  description:'',

};
export type AboutQueryResponse = Response<Array<About>>;
export type QueryResponseAboutContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined
  refetchData: () => void
  isLoading: boolean
  query: any
}
export function createAboutResponseContext<T>(initialState: QueryResponseAboutContextProps<T>) {
  return createContext(initialState)
}
export const initialAboutQueryResponse = { refetchData: () => { }, isLoading: false, query: '' }